import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import UserLayout from '../components/Utils/UserLayout';

import NotFoundPage from '../components/Utils/NotFoundPage';
import PermissionErrorPage from '../components/Utils/PermissionErrorPage';
import LoginPage from '../components/Home/LoginPage';
import HomePage from '../components/Home/HomePage';

import UserRoute from './UserRoute';
import UserManagementPage from '../components/User/UserManagementPage';
import ImoveisManagementPage from '../components/User/Imoveis/ImoveisManagementPage';
import MoveisManagementPage from '../components/User/Moveis/MoveisManagementPage';

import ImoveisPage from '../components/Imoveis/ImoveisPage';
import MoveisPage from '../components/Moveis/MoveisPage';
import Contacts from '../components/Contacts/Contacts';
import PrivacyPolicyPage from '../components/Contacts/PrivacyPolicyPage';
import DashboardPage from '../components/User/DashboardPage';

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        {/* Public Routes - No Layout */}
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/imoveis" element={<ImoveisPage />} />
        <Route path="/outros" element={<MoveisPage />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/login" element={<LoginPage />} />

        {/* User Protected Routes - Wrapped with UserRoute and UserLayout */}
        <Route path="/user/dashboard" element={<UserRoute element={<UserLayout><DashboardPage /></UserLayout>} allowedRoles={['Admin']} />} />
        <Route path="/user/usermanagement" element={<UserRoute element={<UserLayout><UserManagementPage /></UserLayout>} allowedRoles={['Admin']} />} />
        <Route path="/user/imoveis" element={<UserRoute element={<UserLayout><ImoveisManagementPage /></UserLayout>} allowedRoles={['Admin', 'Manager']} />} />
        <Route path="/user/outros" element={<UserRoute element={<UserLayout><MoveisManagementPage /></UserLayout>} allowedRoles={['Admin', 'Manager']} />} />

        {/* 404 Route */}
        <Route path="*" element={<NotFoundPage />} />
        <Route path="permission-error" element={<PermissionErrorPage />} />
      </Routes>
    </Router>
  );
}

export default AppRouter;
